import React, { useEffect, useState } from "react";
import plusIcon from "../../../../../Assets/Images/Svg/plusIcon.svg";
import { Modal } from "antd";
import AddChronicCondition from "./AddChronicCondition";
import moment from "moment";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import { useSelector } from "react-redux";
import { FiPlus } from "react-icons/fi";
import dayjs from "dayjs";

function ChronicCondition({ permissionData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chronicConditions, setChronicConditions] = useState([]);
  const { selectedRpmPatient } = useSelector((state) => state.rpm);

  useEffect(() => {
    PatientchronicConditions();
  }, [permissionData]);

  const handleLatestUpdate = (data) => {
    setChronicConditions(data);
  };

  const PatientchronicConditions = () => {
    const patientRaw = sessionStorage.getItem("patient");
    let patientData = patientRaw ? JSON.parse(patientRaw) : null;

    const userObj = sessionStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;

    const patientId = patientData?.patientId || selectedRpmPatient?.patientId;

    if (permissionData) {
      let payload = {
        patientId,
        // account_Id: userData?.user?.account_Id,
        // clinic_Id: userData?.user?.clinic_Id,
        userId:
          permissionData === null || permissionData?.medicalHistory === "N"
            ? userData?.user?.userId
            : "",
        status: 1,
      };
      MedicalHistoryService.PatientchronicConditions(payload).then((result) => {
        setChronicConditions(result.data);
      });
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  return (
    <>
      {/* <div className=" h-[300px] m-5 border rounded-lg">
        <div className=" h-[20%] bg-brand-primaryColor flex items-center justify-between  rounded-lg p-2">
          <h1 className="font-bold text-normal text-white  mt-3">
            Chronic Conditions
          </h1>
          <img
            src={plusIcon}
            onClick={showModal}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className=" h-[70%] overflow-y-auto bg-[#DEF3F2] custom-scrollbar p-2">
          {chronicConditions?.length > 0
            ? chronicConditions?.map((user, i) => (
                <div>
                  <div key={i} className="items-center mt-3 font-light text-sm">
                    <p className="font-semibold">
                      Condition :{" "}
                      <span className="ml-2 font-medium text-gray-500">
                        {user.chronicDescription}
                      </span>
                    </p>
                  </div>
                  <div className="ml-auto flex justify-end font-medium text-sm">
                    check up date : {user.givenDate?.slice(0, 11)}
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-brand-primaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">
            Chronic Conditions
          </h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={showModal}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-brand-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-52 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {chronicConditions.length > 0 ? (
            chronicConditions.map((user, i) => (
              <div className="relative">
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FAFFF7] border border-[#B7EE9E] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong> Chronic Condition: </strong>
                      {user.chronicDescription}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <Modal
        title={
          <span className="font-bold text-base">Add Chronic Condition</span>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <AddChronicCondition
          onClose={handleCancel}
          handleLatestUpdate={handleLatestUpdate}
          permissionData={permissionData}
        />
      </Modal>
    </>
  );
}

export default ChronicCondition;
